<template lang="html">
  <NewsForm v-if="newsitem!=='undefined'" adminmethod="update" :newsitem="newsitem"/>
</template>

<script>
import NewsForm from './NewsForm.vue';

export default {
  components: {
    NewsForm,
  },
  computed: {
    newsitem(){
      return this.$store.getters.allNews.filter(n=>n.id==this.$route.params.id)[0]
    }
  }
}
</script>

<style lang="scss" scoped>
</style>
